<template>
	<div class="auth">
		<div class="auth-title">
			安全可靠的信息技术已获得权威认证
		</div>
		<div class="auth-content">
			<div class="auth-scroll-content">
				<div class="auth-item" v-for="(auth, index) in authList" :key="index">
					<el-image class="auth-img" :src="auth.src" :lazy="index < 5"></el-image>
					<div class="auth-info">{{ auth.title }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { config } from '../../../constant/config.js'
export default {
	data() {
		return {
			authList: [...config.auth, ...config.auth]
		}
	},
	mounted() {
	},
	methods: {
	},

}
</script>

<style lang="less" scoped>
.auth {
	background-color: @mainTextColor;

	.auth-title {
		font-size: 40px;
		line-height: 40px;
		padding: @commonPadding @commonPadding 40px @commonPadding;
	}



	.auth-content {
		width: 100vw;
		overflow: hidden;
		white-space: nowrap;
		height: calc(250px + @commonPadding);

		position: relative;

		&::before {
			content: "";
			position: absolute;
			top: 0;
			bottom: 0;
			height: 200px;
			right: 0;
			width: 250px;
			background-image: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
			z-index: 9;
		}

		&::after {
			content: "";
			position: absolute;
			top: 0;
			bottom: 0;
			height: 200px;
			left: 0;
			width: 250px;
			z-index: 9;
			background-image: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
		}

		.auth-scroll-content {
			position: absolute;
			display: grid;
			width: calc(100vw / 5 * 18);
			top: 0;
			left: 0;
			grid-template-columns: repeat(auto-fill, calc(100vw / 5));
			animation: scroll 20s linear infinite normal;

			.auth-item {
				height: 200px;
				display: flex;
				justify-content: center;
				flex-direction: column;
				align-items: center;

				.auth-img {
					padding: 30px;
					width: 170px;
					height: 170px;

					/deep/.el-image__inner {
						object-fit: contain;
					}
				}

				.auth-info {
					font-size: 16px;
				}
			}
		}


	}

	@media @mobile {
		.auth-title {
			font-size: @fontSize24;
			padding: @commonPadding_h5;
		}

		.auth-content {
			height: 190px;

			&::before {
				height: 190px;
			}

			&::after {
				content: "";
				position: absolute;
				top: 0;
				bottom: 0;
				height: 190px;
				left: 0;
				width: 250px;
				z-index: 9;
				background-image: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
			}

			.auth-scroll-content {
				width: calc(100vw / 2 * 18);
				grid-template-columns: repeat(auto-fill, calc(100vw / 2));

				.auth-item {
					height: 100%;

					.auth-img {
						width: 175px;
						height: 135px;

					}

				}
			}


		}
	}
}

@keyframes scroll {
	100% {
		left: calc((0px - 100vw) / 5 * 9);
	}
}
</style>